import { useState } from 'react';
import type { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
// import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';

import { useDisclaimerStyles } from './disclaimer.styles.ts';
import { DISCLAIMER } from './constants.ts';
import { Checkbox, ErrorInfoIcon } from '@xlrt/components';

export const DisclaimerPicker = (
  props: FieldExtensionComponentProps<boolean>,
) => {
  const { onChange, formData } = props;

  const [checked, setChecked] = useState<boolean>(!!formData);
  const [expanded, setExpanded] = useState(false);
  const [showError, setShowError] = useState(false);

  const classes = useDisclaimerStyles();

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.checked;

    if (value && !expanded) {
      setShowError(true);
      setChecked(false);
      return;
    }

    setShowError(false);
    setChecked(value);
    onChange(value);
  };

  return (
    <Box className={classes.container}>
      <Box className={classes.warningBox}>
        <Typography className={classes.text}>
          {DISCLAIMER.highlight}{' '}
        </Typography>

        <Box className={classes.inlineRow}>
          <Box className={classes.inlineButtonBox}>
            <Link
              component="button"
              type="button"
              onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                e.preventDefault();
                setExpanded(true);
                setShowError(false);
              }}
            >
              {DISCLAIMER.readMore}
            </Link>
            <span className={classes.asterisk}>*</span>
          </Box>
        </Box>

        {expanded && (
          <Box>
            <Typography className={classes.title}>
              {DISCLAIMER.title}
            </Typography>

            <Typography className={classes.subtitle}>
              {DISCLAIMER.subtitle}
            </Typography>

            <Typography className={classes.text}>{DISCLAIMER.text}</Typography>
          </Box>
        )}

        {showError && (
          <Box className={classes.errorBox}>
            <ErrorInfoIcon />
            <Typography className={classes.errorText}>
              Please review the disclaimer before confirming.
            </Typography>
          </Box>
        )}

        <Checkbox
          name="disclaimer"
          checked={checked}
          onChange={handleCheckboxChange}
        >
          <Typography component="span" className={classes.checkboxLabel}>
            {DISCLAIMER.checkboxLabel}
          </Typography>
        </Checkbox>
      </Box>
    </Box>
  );
};
